export const PDF = 'pdf';
export const XLSX = 'xlsx';
export const INVOICE = 'Invoice';
export const CREDIT_MEMO = 'Credit Memo';
export const CSV = 'CSV';